<script setup lang="ts">
import type { EmitsItemMulti, PropsItemMulti } from './types';

defineProps<PropsItemMulti>();
defineEmits<EmitsItemMulti>();
</script>

<template>
	<div class="top-selector2_itemMulti top-ellipsis">
		{{ name }}
		<span
			class="top-selector2_itemMultiDelete"
			data-top-icon=""
			@click="$emit('delete', id)"
			@mousedown.stop
		></span>
	</div>
</template>

<style>
.top-selector2_itemMulti {
	box-sizing: border-box;
	padding-left: var(--top-padding-2);
	border-radius: var(--top-radius-1, 4px);
	border: 1px solid var(--color-line-primary-1);
	background: var(--color-layer-primary-2);
	min-height: 22px;
	max-width: 100%;
	color: var(--color-text-1);
	flex-grow: 0;
	display: inline-flex;
	align-items: center;
	gap: var(--top-gap-1);
}

.top-selector2_itemMultiDelete {
	--top-icon-size: 14px;
	--top-icon-width: 18px;
	--top-icon-color: var(--color-text-1);

	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	cursor: pointer;
}

.top-selector2_itemMultiDelete:hover {
	background: var(--color-layer-primary-2);
}

@media screen and (min-width: 900px) {
	.top-selector2.top-active .top-selector2_itemMultiDelete {
		z-index: calc(var(--top-popup-z-index) + 1);
	}
}
</style>
